import React from 'react';

export default function Handle({ // your handle component
    handle: { id, value, percent },
    disabled,
    getHandleProps
}) {
  return (
    <div
      style={{
        left: `${percent}%`,
        position: 'absolute',
        marginLeft: -10,
        marginTop: -8,
        zIndex: 2,
        width: 14,
        height: 14,
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '50%',
        backgroundColor: '#FFFFFF',
        color: '#333',
        border: disabled?'1px solid #B6B9BF':'1px solid #1F3C9C'
      }}
      {...getHandleProps(id)}
    >
    </div>
  )
}